// extracted by mini-css-extract-plugin
export default {"form":"auth-modal_form__SLkzT","footer":"auth-modal_footer__undwH","heading":"auth-modal_heading__yTk2J"};